import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-success mb-4"
}
const _hoisted_4 = {
  key: 2,
  class: "flex-center py-10"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "s20 widget p-6 mb-5" }
const _hoisted_7 = { style: {"display":"flex","align-items":"center","gap":"1.5rem"} }
const _hoisted_8 = { style: {"width":"96px","height":"96px","min-width":"96px","flex":"0 0 96px","border-radius":"15px","overflow":"hidden"} }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"flex":"1 1 auto","min-width":"0"} }
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = {
  key: 0,
  class: "ml-2 text-sm text-grey-500"
}
const _hoisted_13 = { class: "flex gap-3" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "s20 widget p-6 mb-5" }
const _hoisted_17 = { class: "flex-right mt-3" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  class: "mb-5",
  style: {"display":"flex","gap":"1.5rem","flex-wrap":"wrap","align-items":"flex-start","clear":"both"}
}
const _hoisted_20 = {
  class: "widget p-6",
  style: {"flex":"1 1 calc(50% - 0.75rem)","min-width":"320px"}
}
const _hoisted_21 = {
  key: 1,
  class: "text-grey-500 py-3"
}
const _hoisted_22 = {
  class: "widget p-6",
  style: {"flex":"1 1 calc(50% - 0.75rem)","min-width":"320px"}
}
const _hoisted_23 = { class: "s20 widget p-6 mb-5" }
const _hoisted_24 = {
  key: 0,
  class: "text-grey-500 py-3"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { style: {"flex":"1 1 auto"} }
const _hoisted_27 = {
  key: 0,
  class: "ml-2 text-sm text-grey-500"
}
const _hoisted_28 = {
  key: 1,
  class: "ml-2 text-sm text-grey-500"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = ["disabled", "onClick"]

import { ref, onMounted, nextTick } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import OnboardingPersonalInfosForm from '@/views/collectivites/onboarding/OnboardingPersonalInfosForm.vue'
import OnboardingIdentityDocumentsForm from '@/views/collectivites/onboarding/OnboardingIdentityDocumentsForm.vue'
import OnboardingPayslipDocumentsForm from '@/views/collectivites/onboarding/OnboardingPayslipDocumentsForm.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserKycView',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(true)
const submitting = ref(false)
const errorMessage = ref('')
const successMessage = ref('')
const detail = ref<any>(null)
const collectivites = ref<any[]>([])
const typesPieceIdentites = ref<any>({})
const personalFormRef = ref<any>(null)

const fullUser = ref<any>(null)

async function fetchDetail() {
  loading.value = true
  errorMessage.value = ''
  try {
    const [kycRes, formRes, userRes] = await Promise.all([
      axios.get(`/backoffice/kyc/members/${route.params.id}`),
      axios.get('/backoffice/onboarding/get_form_datas'),
      axios.get(`/backoffice/users/get/${route.params.id}`),
    ])
    detail.value = kycRes.data
    fullUser.value = userRes.data
    collectivites.value = formRes.data?.collectivites || []
    typesPieceIdentites.value = formRes.data?.types_piece_identites || {}
    loading.value = false
    await nextTick()
    prefillPersonalForm()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors du chargement'
    loading.value = false
  }
}

function prefillPersonalForm() {
  if (!personalFormRef.value) return
  const u = fullUser.value || detail.value?.user
  if (!u) return
  const k = detail.value?.kyc
  Object.assign(personalFormRef.value.formData, {
    nom: k?.nom ?? u.nom ?? null,
    prenom: k?.prenom ?? u.prenom ?? null,
    date_naissance: (k?.date_naissance ?? u.date_naissance) ? String(k?.date_naissance ?? u.date_naissance).substring(0, 10) : null,
    age: u.age ?? 0,
    date_engagement: u.date_engagement ? String(u.date_engagement).substring(0, 10) : null,
    anciennete: u.anciennete ?? 0,
    collectivite_id: u.collectivite_id ?? null,
    salaire: u.salaire ?? '',
    quotite_cessible_pourcent: u.quotite_cessible_pourcent ?? '',
    quotite_cessible_montant: u.quotite_cessible_montant ?? '',
    telephone: u.telephone ?? null,
    email: u.email ?? null,
  })
}

async function onPersonalFormSaved(payload: any) {
  submitting.value = true
  errorMessage.value = ''
  successMessage.value = ''
  try {
    await axios.put(`/backoffice/kyc/members/${route.params.id}`, {
      nom: payload.nom,
      prenom: payload.prenom,
      date_naissance: payload.date_naissance,
    })
    successMessage.value = 'Profil KYC enregistré'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors de la sauvegarde'
  } finally {
    submitting.value = false
  }
}

function triggerSavePersonal() {
  personalFormRef.value?.onSubmit()
}

async function uploadKycDocument(typeDocument: string, file: any, extra: { numero?: string; expiration?: string } = {}) {
  const fd = new FormData()
  fd.append('type_document', typeDocument)
  fd.append('fichier', file)
  if (extra.numero) fd.append('numero', extra.numero)
  if (extra.expiration) fd.append('expiration', extra.expiration)
  await axios.post(`/backoffice/kyc/members/${route.params.id}/documents`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

async function onIdentityDocumentsSaved(payload: any) {
  submitting.value = true
  errorMessage.value = ''
  successMessage.value = ''
  try {
    const typeLabel = typesPieceIdentites.value[payload.type_piece_identite] || 'cni'
    const isPassport = String(typeLabel).toLowerCase().includes('pass')

    if (payload.photo?.file) {
      await uploadKycDocument('photo', payload.photo.file)
    }
    if (payload.piece_recto?.file) {
      await uploadKycDocument(isPassport ? 'passeport' : 'cni_recto', payload.piece_recto.file, {
        numero: payload.numero_piece_identite,
      })
    }
    if (payload.piece_verso?.file && !isPassport) {
      await uploadKycDocument('cni_verso', payload.piece_verso.file, {
        numero: payload.numero_piece_identite,
      })
    }
    successMessage.value = 'Pièces d\'identité enregistrées'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors de l\'enregistrement des pièces'
  } finally {
    submitting.value = false
  }
}

async function onPayslipDocumentsSaved(payload: any) {
  submitting.value = true
  errorMessage.value = ''
  successMessage.value = ''
  try {
    if (payload.bulletin1?.file) await uploadKycDocument('bulletin1', payload.bulletin1.file)
    if (payload.bulletin2?.file) await uploadKycDocument('bulletin2', payload.bulletin2.file)
    if (payload.bulletin3?.file) await uploadKycDocument('bulletin3', payload.bulletin3.file)
    successMessage.value = 'Bulletins de salaire enregistrés'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors de l\'enregistrement des bulletins'
  } finally {
    submitting.value = false
  }
}

async function validateKyc() {
  if (!confirm('Confirmer la validation du KYC de ce membre ?')) return
  submitting.value = true
  errorMessage.value = ''
  try {
    await axios.post(`/backoffice/kyc/members/${route.params.id}/validate`)
    successMessage.value = 'KYC validé'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors de la validation'
  } finally {
    submitting.value = false
  }
}

async function rejectKyc() {
  if (!confirm('Confirmer le rejet du KYC de ce membre ?')) return
  submitting.value = true
  errorMessage.value = ''
  try {
    await axios.post(`/backoffice/kyc/members/${route.params.id}/reject`)
    successMessage.value = 'KYC rejeté'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors du rejet'
  } finally {
    submitting.value = false
  }
}

async function deleteDocument(docId: number) {
  if (!confirm('Supprimer ce document ?')) return
  submitting.value = true
  try {
    await axios.delete(`/backoffice/kyc/members/${route.params.id}/documents/${docId}`)
    successMessage.value = 'Document supprimé'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors de la suppression'
  } finally {
    submitting.value = false
  }
}

function statutLabel(): { label: string; cls: string } {
  const s = detail.value?.kyc?.statut
  if (!detail.value?.kyc) return { label: 'Pas de KYC', cls: 'tag-state warning stroke' }
  if (s === 'verified') return { label: 'Validé', cls: 'tag-state success stroke' }
  if (s === 'rejected') return { label: 'Rejeté', cls: 'tag-state danger stroke' }
  return { label: 'En attente', cls: 'tag-state warning stroke' }
}

onMounted(fetchDetail)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "page-space-40" }, null, -1)),
    _createElementVNode("button", {
      class: "btn white2 mb-4",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
    }, "← Retour"),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (successMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(successMessage.value), 1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : (detail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: detail.value.user.photo_url || '/assets/users_avatar/600w/user.jpg',
                    style: {"width":"100%","height":"100%","object-fit":"cover","display":"block"}
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h3", null, _toDisplayString(detail.value.user.nom) + " " + _toDisplayString(detail.value.user.prenom), 1),
                  _createElementVNode("p", null, _toDisplayString(detail.value.user.email), 1),
                  _createElementVNode("p", null, _toDisplayString(detail.value.user.telephone), 1),
                  _createElementVNode("p", _hoisted_11, [
                    _cache[2] || (_cache[2] = _createTextVNode(" Statut KYC : ", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(statutLabel().cls)
                    }, _toDisplayString(statutLabel().label), 3),
                    (detail.value.kyc?.validator)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (par " + _toDisplayString(detail.value.kyc.validator.nom_complet) + ") ", 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "btn-ultra",
                    disabled: submitting.value || !detail.value.kyc,
                    onClick: validateKyc
                  }, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-valider.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Valider")
                    ], -1)
                  ]))], 8, _hoisted_14),
                  _createElementVNode("button", {
                    class: "btn-ultra danger",
                    disabled: submitting.value || !detail.value.kyc,
                    onClick: rejectKyc
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-denied.svg",
                        class: "btn-icon icon-white",
                        alt: ""
                      }),
                      _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Rejeter")
                    ], -1)
                  ]))], 8, _hoisted_15)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mb-4" }, "Profil KYC", -1)),
              _createVNode(OnboardingPersonalInfosForm, {
                ref_key: "personalFormRef",
                ref: personalFormRef,
                collectivites: collectivites.value,
                "hide-collectivite-field": false,
                "hide-submit-button": true,
                "full-width": true,
                onSaved: onPersonalFormSaved
              }, null, 8, ["collectivites"]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  class: "btn-ultra",
                  disabled: submitting.value,
                  onClick: triggerSavePersonal
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/icons/icon-valider.svg",
                      class: "btn-icon icon-neutral",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Enregistrer")
                  ], -1)
                ]))], 8, _hoisted_18)
              ])
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "mb-4" }, "Pièce d'identité", -1)),
                (Object.keys(typesPieceIdentites.value).length > 0)
                  ? (_openBlock(), _createBlock(OnboardingIdentityDocumentsForm, {
                      key: 0,
                      user: detail.value.user,
                      types_piece_identites: typesPieceIdentites.value,
                      "hide-header": true,
                      onSaved: onIdentityDocumentsSaved
                    }, null, 8, ["user", "types_piece_identites"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, "Chargement des types de pièces..."))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "mb-4" }, "Bulletins de salaire", -1)),
                _createVNode(OnboardingPayslipDocumentsForm, {
                  "form-params": { user: detail.value.user, photo: null },
                  loading: submitting.value,
                  "hide-header": true,
                  "hide-title": true,
                  "hide-previous-link": true,
                  onSaved: onPayslipDocumentsSaved,
                  onPrevious: () => {}
                }, null, 8, ["form-params", "loading"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "mb-4" }, "Documents existants", -1)),
              (!detail.value.kyc?.documents?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Aucun document fourni. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.kyc.documents, (d) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: d.id,
                        class: "flex align-items-center gap-4 py-3 border-bottom"
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("strong", null, _toDisplayString(d.typeDocument), 1),
                          (d.numero)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "N° " + _toDisplayString(d.numero), 1))
                            : _createCommentVNode("", true),
                          (d.expiration && d.expiration !== '--')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, " Exp. " + _toDisplayString(d.expiration.substring(0, 10)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (d.fichierUrl)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: d.fichierUrl,
                              target: "_blank",
                              class: "btn white2"
                            }, "Voir", 8, _hoisted_29))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "btn-ultra danger",
                          disabled: submitting.value,
                          onClick: ($event: any) => (deleteDocument(d.id))
                        }, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("div", { class: "btn-show" }, [
                            _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Supprimer")
                          ], -1)
                        ]))], 8, _hoisted_30)
                      ]))
                    }), 128))
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})